// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"IconButton_iconButton__2gQzf","primary":"IconButton_primary__2t3Bn","ghost":"IconButton_ghost__34IgX"};